import React, { useEffect } from "react";
import "./checkoutDone.scss";
import { CheckCircle } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { resetCart } from "../../redux/cartReducer";

const CheckoutDone = () => {
  const products = useSelector((state) => state.cart.products);

  const dispatch = useDispatch();

  useEffect(() => {
    // Clear cart when this page is opened
    dispatch(resetCart());
  }, [dispatch]);

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="checkout-done">
          <div className="checkout-card">
            <CheckCircle className="icon" size={70} />
            <h1>Thank you !</h1>
            <p>Your order has been placed successfully.</p>
            <div className="actions">
              <button
                className="btn btn-secondary"
                onClick={() => (window.location.href = "/")}
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutDone;
